import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import { store } from "./app/store";
import AppRootProviders from "./app/AppRootProviders";
import "./lib/i18n";
import "./index.css";
import { getCurrentThemeMode, setThemeMode } from "./utils/theme.utlis";
import AppRoutesComponent from "./app/routes/AppRoutesComponent";
import { ToastProvider } from "./components/toast-container";

// Initialize dark mode before rendering
const initializeDarkMode = () => {
  const isDark = getCurrentThemeMode();
  setThemeMode(isDark);
};

initializeDarkMode();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <ToastProvider>
          <AppRootProviders>
            <AppRoutesComponent />
          </AppRootProviders>
        </ToastProvider>
      </Router>
    </Provider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
